import ja from 'date-fns/locale/ja';
import React, { FC, useCallback, useEffect, useState } from 'react';
import DatePicker, { registerLocale } from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import classes from '../../asset/css/change-delivery-date-modal/modal.module.css';
import modalClasses from '../../asset/css/common-modal.module.css';
import { Summary } from '../../hooks/use-subscription-summary';
import { CommonModal } from '../CommonModal';

registerLocale('ja', ja);

export const ChangeDeliveryDateModal: FC<{
  active: boolean;
  scrollOffset: number;
  parentViewportHeight: number;
  marginToTop: number;
  summary: Summary | undefined;
  updateDeliveryDate: (date: Date | undefined, time: string | undefined) => void;
  closeFunc: () => void;
}> = ({
  active,
  scrollOffset,
  parentViewportHeight,
  marginToTop,
  summary,
  updateDeliveryDate,
  closeFunc,
}) => {

  const [selectedDeliveryDate, setSelectedDeliveryDate] = useState<Date>();
  const [selectedDeliveryTime, setSelectedDeliveryTime] = useState<string>();
  useEffect(() => {
    if (!summary) return;
    setSelectedDeliveryDate(summary.nextDeliveryDate);
    setSelectedDeliveryTime(summary.deliveryTime);
  }, [summary]);

  const handleChangeDeliveryDate = (value: Date) => {
    value && !Array.isArray(value) &&
      setSelectedDeliveryDate(value);
  }
  const handleChangeDeliveryTime = (event: React.ChangeEvent<HTMLSelectElement>) => {
    setSelectedDeliveryTime(event.target.value);
  }

  const handleSubmit = () => updateDeliveryDate(selectedDeliveryDate, selectedDeliveryTime);

  const content = (
    <>
      <h2>次回お届け日の変更</h2>
      <p style={{textAlign: "left"}}>※決済日は30日ごとで固定です。お届けをしばらく休止したい場合は「停止」をご利用ください。</p>
      <form className={classes.mypage_popup_cycle_form}>
        <div>
          <h3>ご希望のお届け日</h3>
          <DatePicker
            locale="ja"
            dateFormat="yyyy/MM/dd"
            minDate={summary?.nextDeliveryMinDate}
            maxDate={summary?.nextDeliveryMaxDate}
            selected={selectedDeliveryDate}
            disabledKeyboardNavigation
            filterDate={(date) => !summary?.disableDeliveryWeeks[date.getDay()].disabled}
            onChange={handleChangeDeliveryDate}
            onChangeRaw={(e) => e.preventDefault()}
            customInput={
              selectedDeliveryDate ? (
                <div className={classes.mypage_popup_cycle_form_calendar_div}>
                  {selectedDeliveryDate.getFullYear()}/{('0' + (selectedDeliveryDate.getMonth() + 1)).slice(-2)}
                  /{('0' + selectedDeliveryDate.getDate()).slice(-2)}
                </div>
              ) : <></>
            }
          />
          <h3 className={classes.mypage_popup_cycle_form_deliveryTime_heading}>お届け時間帯</h3>
          <select
            onChange={handleChangeDeliveryTime}
            className={classes.mypage_popup_cycle_form_deliveryTime_select}
            value={selectedDeliveryTime}
          >
            {summary && summary.enableDeliveryTimes
              .map((deltime) => (
                <option key={`deliverytime_${deltime.value}`} value={deltime.value}>
                  {deltime.label}
                </option>
              ))}
          </select>
        </div>

        <button type="button" className={modalClasses.mypage_popup_ok} onClick={handleSubmit}>
          変更する
        </button>
      </form>
    </>
  );

  return <CommonModal 
    active={active}
    scrollOffset={scrollOffset}
    parentViewportHeight={parentViewportHeight}
    marginToTop={marginToTop}
    closeFunc={closeFunc}
    content={content} />;
};
